<template>
	<div class="calculator__configuratoritem">
		<div v-if="!item.isPlaceholder" class="calculator__configuratoritem-field">
			<div v-if="switchTypeOptions" class="calculator__configuratoritem-type-wrapper">
				<SwitchButtons :options="switchTypeOptions" :onSwitch="onSwitchType" />
			</div>

			<InputField
				:name="`_calculator__configurator-add__${item.key}`"
				:label="item.label"
				:value="item.title"
				:required="!item.parts"
				:invalidHint="invalidHint"
				@input="onInput"
			/>

			<div class="calculator__configuratoritem-deceased-wrapper">
				<InputSwitch
					v-if="!item.isCustom"
					:id="`_calculator__configurator-add__${item.key}-switch`"
					:label="$t('deceased')"
					:checked="!!item.parts"
					@change="onSwitchDeceased"
				/>
			</div>

			<div class="calculator__configuratoritem-remove-wrapper">
				<button
					v-if="item.isRemovable"
					type="button"
					class="mdc-button calculator__configuratoritem-remove"
					:aria-label="$t(`removePerson`)"
					@click="onRemove"
				>
					✕
				</button>
			</div>
		</div>
		<span v-else>{{ item.title }}</span>

		<transition @enter="enter" @leave="leave">
			<div v-if="item.parts && !item.hideParts" class="calculator__configuratoritem-parts">
				<ul class="calculator__configuratoritem-items">
					<transition-group @enter="enter" @leave="leave">
						<li v-for="(part, index) in item.parts" :key="part.key">
							<ConfiguratorItem
								:item="part"
								:parent="item"
								:groupKey="groupKey"
								:level="level + 1"
								:index="index"
							/>
						</li>
					</transition-group>
				</ul>

				<AddButton
					v-if="!item.isPlaceholder"
					:addKey="item.key"
					:groupKey="groupKey"
					:level="level + 1"
					class="calculator__configuratoritem-add"
				/>
			</div>
		</transition>
	</div>
</template>

<script>
import InputField from '../components/InputField';
import InputSwitch from '../components/InputSwitch';
import SwitchButtons from '../components/SwitchButtons';
import AddButton from '../components/AddButton';
import animate from '../utils/animate';

export default {
	name: 'ConfiguratorItem',
	mixins: [animate],
	props: {
		item: Object,
		parent: Object,
		groupKey: String,
		level: Number,
		index: Number
	},
	components: {
		InputField,
		InputSwitch,
		SwitchButtons,
		AddButton
	},
	computed: {
		switchTypeOptions() {
			if (!this.item.isCustom) {
				return null;
			}

			const switchOptions = [
				{
					label: this.$t('customizeShareHeir'),
					hint: this.$t('customizeShareHeirHint'),
					key: 'heir',
					isSelected: !this.item.isLegatee
				},
				{
					label: this.$t('customizeShareLegatee'),
					hint: this.$t('customizeShareLegateeHint'),
					key: 'legatee',
					isSelected: this.item.isLegatee
				}
			];

			return switchOptions;
		},
		invalidHint() {
			const hasHint =
				(this.groupKey === 'thirdParentela' && this.level > 2) ||
				(this.groupKey !== 'thirdParentela' && this.level > 1);
			const invalidHint = hasHint ? this.$t('deceasedHint') : null;

			return invalidHint;
		}
	},
	methods: {
		onInput($event) {
			this.$store.commit('setConfiguratorItemTitle', {
				key: this.item.key,
				title: $event.target.value
			});
		},
		onSwitchDeceased($event) {
			this.$store.commit('setConfiguratorItemDeceased', {
				key: this.item.key,
				isDeceased: $event.target.checked
			});
		},
		onRemove() {
			this.$store.commit('removeConfiguratorItemPart', {
				key: this.item.key
			});
		},
		onSwitchType(optionKey) {
			this.$store.commit('setConfiguratorItemType', {
				key: this.item.key,
				isLegatee: optionKey === 'legatee'
			});
		}
	}
};
</script>

<style>
@import url('../assets/css/variables.css');

.calculator__configuratoritem-field {
	display: flex;
	align-items: flex-start;
	margin-top: 12px;
}

.calculator__configuratoritem-type-wrapper {
	margin-right: 20px;
}

.calculator__configuratoritem .calculator__input {
	flex: 1;
}

.calculator__configuratoritem-deceased-wrapper {
	--mdc-theme-secondary: black;

	margin-top: 16px;
	width: 140px;
}

.calculator__configuratoritem-deceased-wrapper .calculator__switch {
	margin-left: 20px;
}

.calculator__configuratoritem-parts {
	margin-left: 24px;
	margin-bottom: 24px;
}

.calculator__configuratoritem-items {
	list-style-type: none;
	padding: 0;
	margin: 0;
}

.calculator__configuratoritem-remove-wrapper {
	width: 36px;
	margin-left: 24px;
}

.calculator__configuratoritem-remove.calculator__configuratoritem-remove {
	min-width: 36px;
	color: var(--color-warning);
	font-weight: bold;
	min-height: 3rem;
}

.calculator__configuratoritem-add {
	margin-top: 12px;
}

/* Tablet */
@media (min-width: 48rem) {
	.calculator__calculator__configuratoritem {
	}
}

/* Desktop */
@media (min-width: 64rem) {
	.calculator__configuratoritem-hint.calculator__configuratoritem-hint {
		font-size: 0.875em;
		color: var(--color-hint);
		width: calc(100% - 140px - 64px - 24px);
		margin: 18px 0;
	}
}
</style>
